import React from "react";
import { Box } from "@mui/material";
import SectionTitle from "../../../../../SectionTitle";
import { UIIcon } from "../../../../../ui";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import messages from "../../../../../../assets/locale/messages";
import GenderCount from "../../../GenderCount";
import MaleGenderIcon from "../../../GenderCount/MaleGenderIcon";
import FemaleGenderIcon from "../../../GenderCount/FemaleGenderIcon";
import { getZoneApprovedRequestsCount } from "../zoneStaffing";

import "../../../_EventDetailFields.scss";

const PANEL_TITLE_COLOR =
  "var(--color-sidebar-gradient-start, rgba(49, 35, 125, 1))";
const MALE_COLOR = "var(--color-primary-default, rgba(150, 69, 255, 1))";
const FEMALE_COLOR = "var(--color-fuchsia-default, rgba(217, 70, 239, 1))";

const StaffingSummary = ({ zone }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  const totalApplicants = getZoneApprovedRequestsCount(zone);
  const maleCount =
    zone?.male_applicants_count ??
    zone?.number_of_male_organizers ??
    zone?.males_count ??
    zone?.males ??
    0;
  const femaleCount =
    zone?.female_applicants_count ??
    zone?.number_of_female_organizers ??
    zone?.females_count ??
    zone?.females ??
    0;

  return (
    <Box className="event-zone">
      <SectionTitle
        icon={<UIIcon name="twoUsers" size="sm" decorative />}
        label={t.staffingSummary}
        classNames={{ label: "event-detail-panel-title" }}
        IconSx={{ color: PANEL_TITLE_COLOR }}
      />

      <div className="event-detail-stat-card">
        <span className="event-detail-label">{t.totalApplicants}</span>
        <span className="event-detail-stat-card__value">
          {totalApplicants ? String(totalApplicants).padStart(2, "0") : "0"}
        </span>
      </div>

      <Box className="event-zone__gender-counts">
        <GenderCount
          count={maleCount}
          label={t.male}
          labelColor={MALE_COLOR}
          countColor={MALE_COLOR}
          icon={
            <Box
              component="span"
              sx={{ color: MALE_COLOR, display: "inline-flex", lineHeight: 0 }}
            >
              <MaleGenderIcon />
            </Box>
          }
          classNames={{
            root: "gender-count-root gender-count-root--male",
          }}
        />

        <GenderCount
          count={femaleCount}
          label={t.female}
          labelColor={FEMALE_COLOR}
          countColor={FEMALE_COLOR}
          icon={
            <Box
              component="span"
              sx={{
                color: FEMALE_COLOR,
                display: "inline-flex",
                lineHeight: 0,
              }}
            >
              <FemaleGenderIcon />
            </Box>
          }
          classNames={{
            root: "gender-count-root gender-count-root--female",
          }}
        />
      </Box>
    </Box>
  );
};

StaffingSummary.propTypes = {
  zone: PropTypes.object.isRequired,
};

export default StaffingSummary;
